import { useState, useEffect } from 'react';

export const useOrders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState({
    total: 0,
    totalSpend: 0,
    avgOrderValue: 0
  });

  useEffect(() => {
    // Mock data
    const mockOrders = [
      { id: '1', total: 1000, status: 'delivered', createdAt: new Date() },
      { id: '2', total: 2000, status: 'processing', createdAt: new Date() }
    ];
    
    setOrders(mockOrders);
    
    const totalSpend = mockOrders.reduce((sum, order) => sum + order.total, 0);
    const stats = {
      total: mockOrders.length,
      totalSpend,
      avgOrderValue: mockOrders.length > 0 ? totalSpend / mockOrders.length : 0
    };
    
    setStats(stats);
    setLoading(false);
  }, []);

  return { orders, loading, stats };
};